import { TokenData } from './types';

interface CoreTokenIdentity {
  orgId: string | null;
  userId: string;
}

const isUuid = (value: unknown): value is string => {
  return typeof value === 'string'
    && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    && value !== '00000000-0000-0000-0000-000000000000';
};

export const getCoreTokenIdentity = (token: string): CoreTokenIdentity | null => {
  let value: unknown;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    value = JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')));
  } catch {
    return null;
  }
  if (!value || typeof value !== 'object' || Array.isArray(value) || !('user_id' in value)) return null;
  const payload = value as Record<string, unknown>;
  const orgId = payload.org_id;
  if (!isUuid(payload.user_id) || (orgId != null && !isUuid(orgId))) {
    throw new Error('Не удалось подтвердить данные аккаунта. Войдите ещё раз.');
  }
  return { orgId: typeof orgId === 'string' ? orgId.toLowerCase() : null, userId: payload.user_id.toLowerCase() };
};

export const synchronizeTokenIdentity = (token: TokenData, previous?: TokenData): TokenData => {
  const identity = getCoreTokenIdentity(token.access_token);
  if (identity) return { ...token, org_id: identity.orgId, user_id: identity.userId };
  return {
    ...token,
    org_id: token.org_id !== undefined ? token.org_id : previous?.org_id,
    user_id: token.user_id !== undefined ? token.user_id : previous?.user_id
  };
};